// Shared category matching for the browser catalog and build-time HTML.
const site = require('../seo/site.json');

function normalizeProductType(productType) {
  return String(productType || '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

function resolveProductTypeSectionKey(normalizedType) {
  return site.sections.find((section) => section.typeKeys.includes(normalizedType))?.key || 'other';
}

module.exports = { normalizeProductType, resolveProductTypeSectionKey };
